import React from 'react';
import { getOverallProgress } from '../utils/progress';
import { ROLES } from '../data/roles';
import './GlobalProgressBar.css';

export default function GlobalProgressBar({ state }) {
  if (!state.role) return null;
  const role = ROLES[state.role];
  const { pct, done, total, blocked, inProg } = getOverallProgress(state.progress, state.role);
  const color = pct === 100 ? '#375623' : pct > 0 ? '#2E75B6' : '#CCCCCC';
  const roleColor = { COO:'#1F4E79',PM:'#375623',FC:'#7B3F00',DEV:'#1B4F72',DEVOPS:'#4A235A',TESTER:'#922B21' }[state.role] || '#1F4E79';

  return (
    <div className="global-progress-bar">
      <div className="gpb-info">
        <span className="gpb-role" style={{ color: roleColor }}>{role.label}</span>
        <span className="gpb-stats">
          <span className="gpb-pct" style={{ color }}>{pct}%</span>
          <span className="gpb-sep">·</span>
          <span>{done}/{total} steps</span>
          {inProg > 0 && <><span className="gpb-sep">·</span><span className="gpb-inprog">{inProg} in progress</span></>}
          {blocked > 0 && <><span className="gpb-sep">·</span><span className="gpb-blocked">{blocked} blocked</span></>}
        </span>
      </div>
      <div className="gpb-track">
        {/* Completed */}
        <div className="gpb-fill gpb-fill--done"    style={{ width: `${total ? done/total*100 : 0}%`,   background: '#375623' }} />
        {/* In progress */}
        <div className="gpb-fill gpb-fill--inprog"  style={{ width: `${total ? inProg/total*100 : 0}%`, background: '#2E75B6' }} />
        {/* Blocked */}
        <div className="gpb-fill gpb-fill--blocked" style={{ width: `${total ? blocked/total*100 : 0}%`,background: '#C00000' }} />
      </div>
      <div className="gpb-legend">
        <span className="gpb-legend-dot" style={{background:'#375623'}} /> Done
        <span className="gpb-legend-dot" style={{background:'#2E75B6'}} /> In Progress
        <span className="gpb-legend-dot" style={{background:'#C00000'}} /> Blocked
        <span className="gpb-legend-dot" style={{background:'#CCCCCC'}} /> Not Started
      </div>
    </div>
  );
}
